module.exports = __webpack_public_path__ + "img/default1.d4191337.png";